import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Wrapper} from '../../components/common';
import Lobby from '../../components/Lobby';
import {appId} from '../../store';
import {LIST_PAGE_SIZE} from '../../configs/constants';
import {
  fetchGames, createGame, updateGame,
  onGameCreated, fetchTeamDefinition, onPlayerEnteredGameByDirectLink, fetchMobileBranchIoLink,
} from '../../actions/game';
import {
  confirmMedia, setSidebarStatus, saveUserDefinitions, setHelpStatus,
} from '../../actions/user';
import {onPlayerJoin} from '../../actions/player';
import {gameConfigSelector} from '../../selectors';

class LobbyContainer extends PureComponent {
  static propTypes = {
    fetchGameList: PropTypes.func.isRequired,
    onConfirmMedia: PropTypes.func.isRequired,
    gameConfig: PropTypes.shape({
      id: PropTypes.string,
      playerLimit: PropTypes.number.isRequired,
      isAudienceAllowed: PropTypes.bool,
    }).isRequired,
    isGameListFetching: PropTypes.bool.isRequired,
    isDetailsFetching: PropTypes.bool.isRequired,
    page: PropTypes.number.isRequired,
    query: PropTypes.string.isRequired,
    hasMore: PropTypes.bool.isRequired,
    error: PropTypes.shape({}).isRequired,
    ableToSendGiftsForFree: PropTypes.bool,
  };

  static defaultProps = {
    ableToSendGiftsForFree: false,
  }

  onFetchGames = (params) => {
    const {
      fetchGameList,
      hasMore,
      isGameListFetching,
      page: currentPage,
      query: currentQuery,
    } = this.props;
    const {query = currentQuery, resetPage = false} = params;
    const page = resetPage ? 1 : currentPage;
    if (!isGameListFetching && (resetPage || hasMore)) {
      fetchGameList({
        appId,
        query,
        page,
        size: LIST_PAGE_SIZE,
      });
    }
  };
  render() {
    const {isDetailsFetching, gameConfig: {playerLimit}} = this.props;

    if (!isDetailsFetching) {
      return (
        <Wrapper {...this.props}>
          <div className="cell cell_full">
            <Lobby
              playerLimit={playerLimit}
              onFetchGames={this.onFetchGames}
              {...this.props}
            />
          </div>
        </Wrapper>
      );
    }

    return <div/>;
  }
}
const bindActions = dispatch => (
  {
    fetchGameList: (params, props) => dispatch(fetchGames(params, props)),
    createGame: (params, id) => dispatch(createGame(params, id)),
    onJoinGame: params => dispatch(onPlayerJoin(params)),
    onConfirmMedia: params => dispatch(confirmMedia(params)),
    updateGame: params => dispatch(updateGame(params)),
    onGameCreated: params => dispatch(onGameCreated(params)),
    fetchGameTeamDefinition: params => dispatch(fetchTeamDefinition(params)),
    fetchMobileBranchIoLink: params => dispatch(fetchMobileBranchIoLink(params)),
    onPlayerEnteredGameByDirectLink: params => dispatch(onPlayerEnteredGameByDirectLink(params)),
    saveUserDefinitions: params => dispatch(saveUserDefinitions(params)),
    sidebarToggle: params => dispatch(setSidebarStatus(params)),
    helpToggle: params => dispatch(setHelpStatus(params)),
    dispatch,
  }
);

const mapStateToProps = (state) => {
  const {
    game,
    application: {isDetailsFetching, details: {ableToSendGiftsForFree}},
    error,
    user: {profile, help},
  } = state;
  return ({
    ...game,
    gameConfig: gameConfigSelector(state),
    ableToSendGiftsForFree,
    isDetailsFetching,
    error,
    user: {...profile, help},
  });
};

export default connect(mapStateToProps, bindActions)(LobbyContainer);
